import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode'; // เพิ่ม decode token

function Home() {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const keycloakRegisterUrl =
        "https://keycloak-production-8068.up.railway.app/realms/affiliate-realm/protocol/openid-connect/registrations?client_id=affiliator-client&response_type=token&scope=openid&redirect_uri=https://affiliator-client-react.pages.dev/callback";

    useEffect(() => {
        const token = localStorage.getItem('access_token');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                if (decoded) {
                    setIsLoggedIn(true); // ✅ ถ้า decode สำเร็จ ถือว่า Login แล้ว
                }
            } catch (error) {
                console.error('Token invalid:', error);
            }
        }
    }, []);

    const handleClickViewPackages = () => {
        navigate("/packages");
    };

    return (
        <>
            <section
                className="text-white py-5"
                style={{ background: 'linear-gradient(to right,rgb(31, 6, 44), rgb(64, 12, 91))' }}
            >
                <div className="container text-center">
                    <h1 className="fw-bold mb-4">สมัครเป็นพาร์ทเนอร์กับเรา</h1>
                    <p className="lead mb-4">
                        เข้าร่วมโปรแกรม Affiliate เพื่อโปรโมตแพ็กเกจท่องเที่ยว และรับค่าคอมมิชชั่นจากทุกการจองผ่านเว็บไซต์ของคุณ
                    </p>

                    {/* ✅ แสดงปุ่มสมัครเฉพาะเมื่อยังไม่ได้ Login */}
                    {!isLoggedIn && (
                        <a href={keycloakRegisterUrl} className="btn btn-lg btn-success px-4 me-3 shadow-lg">
                            ✍️ สมัครเป็นพาร์ทเนอร์
                        </a>
                    )}

                    <button onClick={handleClickViewPackages} className="btn btn-lg btn-outline-light px-4 shadow">
                        📦 ดูแพ็กเกจท่องเที่ยว
                    </button>
                </div>
            </section>


            <section className="container py-5">
                <h2 className="fw-bold text-center mb-5">สิ่งที่คุณจะได้รับ</h2>
                <div className="row g-4 text-center">
                    <div className="col-md-4">
                        <div className="p-4 bg-light border rounded h-100">
                            <h5 className="fw-bold">💸 ค่าคอมมิชชั่นสูง</h5>
                            <p>รับรายได้จากทุกการจองที่เกิดจากลิงก์ของคุณ</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 bg-light border rounded h-100">
                            <h5 className="fw-bold">📈 ระบบติดตามเรียลไทม์</h5>
                            <p>ดูยอดคลิก ยอดจองผ่านแดชบอร์ดส่วนตัว</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 bg-light border rounded h-100">
                            <h5 className="fw-bold">🌏 แพ็กเกจหลากหลาย</h5>
                            <p>เลือกโปรโมตแพ็กเกจที่ตรงกับกลุ่มเป้าหมายของคุณ</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Home;
